<div class="container container-padding">

    <h1 class="page-header">{{'TIMETABLE.HEADER' | translate}}</h1>

    <div class="separator"></div>

    <div class="box box-white has-shadow">
        <div class="box-content">
            <div class="box-body">
                <table class="table table-lg">
                    <colgroup>
                        <col width="50">
                        <col width="140">
                        <col width="300">
                        <col>
                        <col width="100">
                    </colgroup>
                    <thead>
                    <tr>
                        <td></td>
                        <td>{{ 'LABEL.CREATION_DATE' | translate }}</td>
                        <td>{{ 'SCHEDULE.DATES' | translate }}</td>
                        <td>{{ 'SCHEDULE.AUTHOR' | translate }}</td>
                        <td class="text-right">{{ 'SCHEDULE.OPERATIONS' | translate }}</td>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let item of (list$ | async); let index = index">
                        <td>{{ index + 1}}</td>
                        <td>{{ item.creationTimestamp | lsnDate : timestamp }}</td>
                        <td>{{ item.startTime | lsnDate : timestamp }} - {{ item.endTime | lsnDate : timestamp }}</td>
                        <td>{{ item.author?.fullName || '-' }}</td>
                        <td class="text-right">
                            <button class="btn btn-link btn-slim"
                                    [matTooltip]="'SCHEDULE.TOOLTIP.EDIT_ENTRY' | translate"
                                    (click)="edit(item)">
                                <i class="icon-edit"></i>
                            </button>
                            <button class="btn btn-link btn-no-padding" (click)="delete(item.id)"
                                    [matTooltip]="'SCHEDULE.TOOLTIP.DELETE_ENTRY' | translate">
                                <i class="icon-delete mr-1"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="box-row ng-star-inserted">
                    <div class="box-item text-accent">
                        <button type="button" class="btn btn-link btn-slim" (click)="openTimetableEditAside()">
                            <i class="icon-add mr-2"></i>
                            <span>{{'TIMETABLE.ADD_NEW_TERM' | translate }}</span>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


